import { render, staticRenderFns } from "./rJiezhenDai_list.vue?vue&type=template&id=82e4f46c&scoped=true&"
import script from "./rJiezhenDai_list.vue?vue&type=script&lang=js&"
export * from "./rJiezhenDai_list.vue?vue&type=script&lang=js&"
import style0 from "./rJiezhenDai_list.vue?vue&type=style&index=0&id=82e4f46c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e4f46c",
  null
  
)

export default component.exports